import axios from "axios";
import authHeader from "../Auth/authHeader";
import { ApiLink } from "../APILink/ApiLink";

export async function fetchAccountsByLedger({
  ledgerID,
  search = "",
  page = 1,
  pageSize = 50,
}) {
  const headers = authHeader();

  const response = await axios.get(ApiLink.API_URL + "Accounts/accountsPick", {
    headers,
    params: { ledgerID, search, page, pageSize },
  });

  return response.data;
}
